import InfoHeader from './InfoHeader';
import { InfoHeaderProps, InfoHeaderValueProps } from './types';

export type { InfoHeaderProps, InfoHeaderValueProps };
export default InfoHeader;
